import { CreateTwoTone } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../hooks/useToast";
import Formservice from "./../service/Formservice";
import logo from "./logo.png";
import Menu from "./Menu";
import Message from "./Message";
import Identifiant from "./reusable/Identifiant";
import NB from "./reusable/NB";
import {
  DIPLOME_DATA,
  FILIERE_DATA,
  INCLUDED_CI_FILIERE,
} from "./utils/Extre_data";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

const INIT_FORM_ERRORS = {
  diplome_error: null,
  filiere_error: null,
  parsours_error: null,
  annee_error: null,
  etablissement_error: null,
  fichier_error: null,
};

function Etude() {
  const navigate = useNavigate();
  const [dataDiplome, setDataDiplome] = useState(DIPLOME_DATA);
  const ref = localStorage.getItem("ref");
  const parts = ref.split("_");
  const prefix = parts[0];
  const apiurl = process.env.REACT_APP_API_FILE;
  const [selectedYear, setSelectedYear] = useState(null);
  const { Toast, showToast } = useToast();
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [form, setForm] = useState({
    id: "",
    diplome: "",
    filiere: "",
    annee: "",
    description: "",
    etablissement: "",
    autrefiliere: "",
  });

  const [tableData, setTableData] = useState([]);
  const [identif, setIdentif] = useState({});
  const years = [];
  const currentYear = new Date().getFullYear();
  const [isEdit, setIsEdit] = useState(false);
  const [formErrors, setFormError] = useState(INIT_FORM_ERRORS);
  const [filieres, setFilieres] = useState(FILIERE_DATA);
  const [submited, setSubmited] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const formRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Détecter si l'écran est mobile

  for (let year = 1950; year <= currentYear; year++) {
    years.push(String(year));
  }

  const handleChangeval = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  const handleChange = (event, value) => {
    setSelectedYear(value);
    setForm({ ...form, annee: value });
  };

  const isFormError = () => {
    return Object.values(formErrors).some((item) => item !== null);
  };

  const objAlreadyExist = () => {
    return tableData.some(
      (item) =>
        String(item.annee).toLowerCase() === String(form.annee).toLowerCase() &&
        String(item.description).toLowerCase() ===
          String(form.description).toLowerCase() &&
        String(item.diplome).toLowerCase() ===
          String(form.diplome).toLowerCase() &&
        String(item.etablissement).toLowerCase() ===
          String(form.etablissement).toLowerCase() &&
        String(item.filiere).toLowerCase() ===
          String(form.filiere).toLowerCase(),
    );
  };

  const handleSave = () => {
    setSubmited(true);
    if (isFormError()) {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
      return;
    }
    const isNewRecord = form.id === "";

    if (isNewRecord && objAlreadyExist()) {
      showToast(TYPE_NOTIFICATION.ERROR, "Ces informations sont dejà inserées");
      setLoadingAdd(false);
      return;
    }

    if (!isNewRecord && form.filiere === "Autres" && form.autrefiliere === "") {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez préciser l'autre filière",
      });
      return;
    }

    if (
      form.diplome === "" ||
      form.filiere === "" ||
      form.annee === "" ||
      form.description === "" ||
      form.etablissement === ""
    ) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez compléter tous les champs obligatoires",
      });
      return;
    }

    const newData = {
      diplome: form.diplome,
      filiere: form.filiere === "Autres" ? form.autrefiliere : form.filiere,
      annee: selectedYear,
      description: form.description,
      etablissement: form.etablissement,
      attestation: form.attestation,
    };

    const formServiceCall = isNewRecord
      ? Formservice.saveetude(newData, ref)
      : Formservice.updateetude(newData, ref, form.id);

    setLoadingAdd(true);
    formServiceCall
      .then((result) => {
        if (result.status) {
          setSubmited(false);
          setTableData(result.data);
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur lors de l'insertion",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "Erreur lors de l'insertion",
        });
      })
      .finally(() => {
        setLoadingAdd(false);
        setSelectedYear(null);
        setForm({
          id: "",
          diplome: "",
          filiere: "",
          annee: "",
          description: "",
          etablissement: "",
          attestation: "",
          autrefiliere: "",
        });
        document.getElementById("attestation").value = "";
        setIsEdit(false);
      });
  };

  const handleCheckFormError = () => {
    setFormError({
      annee_error: !form.annee
        ? "Année d'obtention requis"
        : Number(form.annee) - dayjs(identif.ddn).get("year") < 5
          ? "Veuillez saisir une année d'obtention valide"
          : null,
      diplome_error: !form.diplome ? "Diplôme requis" : null,
      etablissement_error: !form.etablissement ? "Etablissement requis" : null,
      filiere_error: !form.filiere /* || form.filiere === "Autres" */
        ? "Filiere requis"
        : null,
      parsours_error: !form.description ? "Parcours requis" : null,
      fichier_error: !form.attestation ? "Attestation requis" : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleEdit = (index) => {
    let result = tableData.find((item) => item.id_etude === index);
    setForm({
      id: result.id_etude,
      diplome: result.diplome,
      filiere: result.filiere,
      annee: result.annee,
      description: result.description,
      etablissement: result.etablissement,
      attestation: result.file_diplome,
    });

    setSelectedYear(result.annee);
    if (result.file_diplome !== null) {
      setIsEdit(true);
    }

    // Scroller vers le formulaire
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    }, 10);
  };

  const handleDelete = (index) => {
    Formservice.deleteetude(index, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          setTableData(result.data);
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur lors de la suppression",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "Erreur lors de la suppression",
        });
      });
  };

  const handleenvoie = () => {
    const formIsComplete = [
      "diplome",
      "filiere",
      "annee",
      "etablissement",
    ].every((field) => form[field] !== "");

    if (formIsComplete) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo:
          "Veuillez d'abord cliquer sur Ajouter ou Modifier avant de continuer.",
      });
    } else if (tableData.length === 0) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo:
          "Veuillez compléter le champ du tableau avant de continuer.",
      });
    } else {
      navigate("/experience");
    }
  };

  function onFileChange(event) {
    const file = event.target.files[0];

    const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];
    if (file && !allowedTypes.includes(file.type)) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez télécharger un fichier PDF, PNG ou JPG.",
      });
      event.target.value = "";
      return;
    }

    const maxSize = 3 * 1024 * 1024;
    if (file && file.size > maxSize) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "La taille du fichier doit être inférieure à 3 Mo.",
      });
      event.target.value = "";
      return;
    }
    setForm({ ...form, attestation: file });
    setIsEdit(false);
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const handleretour = () => {
    navigate("/etatcivil");
  };

  const handleFetchDiplome = (min_diplome) => {
    Formservice.recupererDiplome(min_diplome).then((result) => {
      if (result && result.data) {
        setDataDiplome(result.data);
      }
    });
  };

  useEffect(() => {
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        setIdentif(result.data);
        handleFetchDiplome(result.data.diplome_minimum);
        setTableData(result.etude);
      }
    });
  }, []);

  useEffect(() => {
    if (identif.desc === "Cons_indiv") {
      setDataDiplome(
        dataDiplome.filter((item) => !["BEPC", "CEPE"].includes(item.label)),
      );
      setFilieres(INCLUDED_CI_FILIERE.sort((a, b) => a.label - b.label));
    }
  }, [identif]);

  useEffect(() => {
    if (form) handleCheckFormError();
  }, [form]);

  return (
    <Grid container ref={formRef} display={"flex"} justifyContent={"center"}>
      <Toast />
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Menu />
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        p={2.5}
      >
        <main>
          <Grid container item xs={12} justifyContent={"center"}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                maxWidth: "75px",
                maxHeight: "75px",
                // marginLeft: "40%",
                // display: window.innerWidth <= 600 ? "block" : "none",
              }}
            />
          </Grid>
          <Grid container justifyContent={"center"}>
            <h1 style={{ marginBottom: "10px", textAlign: "center" }}>
              Cursus universitaire
            </h1>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Identifiant identif={identif} prefix={prefix} refer={ref} />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                style={{ marginBottom: "20px", color: "red" }}
              >
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires",
                    "Le bouton Ajouter permet d'enregistrer les formations académiques.",
                    "Veuillez cliquer sur suivant pour passer au suivant.",
                  ]}
                />
              </Grid>
            </Grid>
            <Grid item>
              <fieldset>
                <legend>Etudes</legend>
                <Grid container>
                  <Grid item xs={12}>
                    <TableContainer
                      component={Paper}
                      sx={{ width: { xs: "90vw", md: "78vw", lg: "55vw" } }}
                      style={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        overflow: "auto",
                      }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow
                            style={{ backgroundColor: "gray", padding: "0px" }}
                          >
                            <TableCell>Diplôme</TableCell>
                            <TableCell>Filière</TableCell>
                            <TableCell>Année</TableCell>
                            <TableCell>Parcours</TableCell>
                            <TableCell>Établissement</TableCell>
                            <TableCell>Attestation/Diplôme</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableData.map((data, index) => (
                            <TableRow key={index}>
                              <TableCell>{data.diplome}</TableCell>
                              <TableCell>{data.filiere}</TableCell>
                              <TableCell>{data.annee}</TableCell>
                              <TableCell>{data.description}</TableCell>
                              <TableCell>{data.etablissement}</TableCell>
                              <TableCell>
                                {data.file_diplome === "" ? (
                                  ""
                                ) : (
                                  <a
                                    href={`${apiurl}/uploads/diplome/${data.file_diplome}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    PJ
                                  </a>
                                )}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  aria-label="edit"
                                  color="primary"
                                  onClick={() => handleEdit(data.id_etude)}
                                >
                                  <CreateTwoTone />
                                </IconButton>
                                <IconButton
                                  aria-label="delete"
                                  color="secondary"
                                  onClick={() => handleDelete(data.id_etude)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={12} lg={3}>
                    <label>Diplôme * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      style={{ width: "100%", marginBottom: "15px" }}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Diplôme
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        label="direction"
                        value={form.diplome}
                        name="diplome"
                        onChange={handleChangeval}
                        error={formErrors.diplome_error && submited}
                      >
                        {dataDiplome.map((item, idx) => (
                          <MenuItem key={idx} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText sx={{ color: "error.main" }}>
                        {submited ? formErrors.diplome_error : ""}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <label>Filière * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      style={{ width: "100%", marginBottom: "15px" }}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Filière
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        label="direction"
                        value={form.filiere}
                        name="filiere"
                        error={formErrors.filiere_error && submited}
                        onChange={handleChangeval}
                      >
                        {filieres.map((item, idx) => (
                          <MenuItem key={idx} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText sx={{ color: "error.main" }}>
                        {submited ? formErrors.filiere_error : ""}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  {form.filiere === "Autres" && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <label>Autres filière * :</label>
                      </Grid>
                      <Grid item xs={12} lg={9}>
                        <TextField
                          style={{ width: "100%", marginBottom: "15px" }}
                          id="outlined-basic"
                          size="small"
                          label="Description"
                          variant="outlined"
                          name="autrefiliere"
                          value={form.autrefiliere}
                          onChange={handleChangeval}
                          error={formErrors.filiere_error && submited}
                          helperText={formErrors.filiere_error}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} lg={3}>
                    <label>Parcours * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      style={{ width: "100%", marginBottom: "15px" }}
                      id="outlined-basic"
                      size="small"
                      label="Parcours"
                      error={formErrors.parsours_error && submited}
                      helperText={submited ? formErrors.parsours_error : ""}
                      variant="outlined"
                      name="description"
                      value={form.description}
                      onChange={handleChangeval}
                    />
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <label>Année * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <Autocomplete
                      value={selectedYear}
                      size="small"
                      onChange={handleChange}
                      options={years}
                      style={{ width: "100%", marginBottom: "15px" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={formErrors.annee_error && submited}
                          helperText={submited ? formErrors.annee_error : ""}
                          size="small"
                          label="Sélectionnez une année"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <label>Établissement * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      style={{ width: "100%", marginBottom: "30px" }}
                      id="outlined-basic"
                      size="small"
                      label="Votre établissement sans abréviation"
                      variant="outlined"
                      name="etablissement"
                      error={formErrors.etablissement_error && submited}
                      helperText={
                        submited ? formErrors.etablissement_error : ""
                      }
                      value={form.etablissement}
                      onChange={handleChangeval}
                    />
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <label>Attestation/Diplôme * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <input
                      type="file"
                      id="attestation"
                      name="attestation"
                      accept=".pdf, .png, .jpg, .jpeg"
                      onChange={onFileChange}
                      style={{ marginBottom: "15px" }}
                      // color={(formErrors.fichier_error)?"error.main":"black"}
                    />
                    {isEdit && (
                      <a
                        href={`${apiurl}/uploads/diplome/${form.attestation}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "10px", textDecoration: "none" }}
                      >
                        {form.attestation}
                      </a>
                    )}
                    <FormHelperText sx={{ color: "error.main" }}>
                      {submited ? formErrors.fichier_error : ""}
                    </FormHelperText>
                    <Alert
                      sx={{
                        mb: 1,
                      }}
                      severity="info"
                      variant="outlined"
                    >
                      Format du fichier accepté: pdf, Taille max : 3Mo
                    </Alert>
                  </Grid>
                  <Grid container justifyContent={"end"}>
                    <LoadingButton
                      variant="contained"
                      color="primary"
                      loading={loadingAdd}
                      // disabled={Object.values(formErrors).some(
                      //   (err) => err !== null
                      // )}
                      style={{
                        marginBottom: "10px",
                      }}
                      onClick={handleSave}
                    >
                      {form.id === "" ? "Ajouter" : "Modifier"}
                    </LoadingButton>
                  </Grid>
                </Grid>
              </fieldset>
            </Grid>
          </Grid>

          <Grid
            item
            mt={3}
            mb={3}
            display={"flex"}
            justifyContent={"space-between"}
          >
            <Button variant="outlined" onClick={handleretour}>
              Retour
            </Button>
            <LoadingButton
              variant="outlined"
              sx={{ marginLeft: "auto" }}
              onClick={handleenvoie}
              color="primary"
            >
              Suivant
            </LoadingButton>
          </Grid>
        </main>
        <footer
          style={{
            color: "#0747a1",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE
          DEVELOPPEMENT
        </footer>
      </Grid>
    </Grid>
  );
}

export default Etude;
